import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { stateAbbreviations } from '../../core/constant';
import { Subscription } from "rxjs";
import { customEmailValidator } from '../../core/utils/custom-email-validator.utils';
import { FormGroup, Validators } from '@angular/forms';
import { debounceTime, distinctUntilChanged } from "rxjs/operators";

@Component({
  selector: 'app-pm-details-form',
  templateUrl: './pm-details-form.component.html',
  styleUrls: ['./pm-details-form.component.scss']
})
export class PmDetailsFormComponent implements OnInit, OnDestroy {
  @Input() form: FormGroup;
  @Input() isUpdater;
  stateList = stateAbbreviations;
  subscription = new Subscription();
  excludeFields = ['address2'];

  ngOnInit(): void {
    this.disableForm();

    setTimeout(() => {
      const sub = this.form.controls.entity_type.valueChanges.subscribe(() => {
        if (!this.isFormEmpty(this.form.value)) {
          this.setValidatorsBasedOnEntity();
        }
      });

      this.subscription.add(sub);
    });

    const formSub = this.form.valueChanges.pipe(
      debounceTime(250),
      distinctUntilChanged()
    ).subscribe(value => {
      if (!this.isUpdater && this.isFormEmpty(value)) {
        this.disableAllValidators();
        return;
      }
      this.enableAllValidators();
    });

    this.subscription.add(formSub);

    if (this.isUpdater) {
      this.enableForm();
    }
  }

  enableForm() {
    Object.keys(this.form.controls).forEach(key => {
      this.form.controls[key].enable({emitEvent: false});
    });
  }

  disableForm() {
    Object.keys(this.form.controls).forEach(key => {
      this.form.controls[key].disable({emitEvent: false});
    });
  }

  /* If at least one Form field is not empty */
  isFormEmpty(value) {
    for (const item in value) {
      if (item === 'entity_type') {
        continue;
      }

      if (this.form.controls[item].value !== '') {
        return false;
      }
    }

    return true;
  }

  disableAllValidators() {
    Object.keys(this.form.controls).forEach(key => {
      if (this.excludeFields.includes(key)) {
        return;
      }
      this.form.controls[key].clearValidators();
      this.form.controls[key].updateValueAndValidity({emitEvent: false});
    });

    this.form.updateValueAndValidity({emitEvent: false});
  }

  enableAllValidators() {
    Object.keys(this.form.controls).forEach(key => {
      if (this.excludeFields.includes(key)) {
        return;
      }
      const validators = [Validators.required];

      if (key === 'email_address') {
        validators.push(customEmailValidator());
      }

      this.form.controls[key].setValidators(validators);
      this.form.controls[key].updateValueAndValidity({emitEvent: false});
    });

    this.setValidatorsBasedOnEntity();
  }

  setValidatorsBasedOnEntity() {
    if (this.form.controls.entity_type.value === 'company') {
      this.form.controls.first_name.disable({emitEvent: false});
      this.form.controls.last_name.disable({emitEvent: false});
      this.form.controls.company_name.enable({emitEvent: false});

      this.form.controls.first_name.clearValidators();
      this.form.controls.last_name.clearValidators();
      this.form.controls.company_name.setValidators([Validators.required]);
    } else if (this.form.controls.entity_type.value === 'person') {
      this.form.controls.first_name.enable({emitEvent: false});
      this.form.controls.last_name.enable({emitEvent: false});
      this.form.controls.company_name.disable({emitEvent: false});

      this.form.controls.first_name.setValidators([Validators.required]);
      this.form.controls.last_name.setValidators([Validators.required]);
      this.form.controls.company_name.clearValidators();
    }
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  get f() {
    return this.form.controls;
  }
}
